module.exports = __webpack_public_path__ + "static/img/menu3.db31d0d4.png";